export default theme => ({
  buttonItem: {
    margin: theme.spacing.unit,
    maxWidth: 500,
  },
});
